import React from 'react';
import ReactDOM from 'react-dom';
import './fonts.css';
import './index.css';
import './spinkit.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { CookiesProvider } from 'react-cookie';
import IntlContext from './context/IntlContext';
import AppVersionContext from './context/AppVersionContext';
import theme from './theme';

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline>
                <StyledEngineProvider injectFirst>
                    <IntlContext>
                        <AppVersionContext>
                            <CookiesProvider>
                                <BrowserRouter>
                                    <App />
                                </BrowserRouter>
                            </CookiesProvider>
                        </AppVersionContext>
                    </IntlContext>
                </StyledEngineProvider>
            </CssBaseline>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const waitingSW = registration.waiting;
      if (waitingSW) {
        waitingSW.postMessage({ type: 'SKIP_WAITING' });
      }
    },
  });

